// import { Link } from "react-router-dom";
// import moreVertical from "../../assets/more-vertical.png";
// import { Btn, SimpleButton } from "../../components/button.jsx/Btn";
// import { Modal } from "../../components/modal";
// import docs from "../../";
// import { useState } from "react";
// import { FaImage, FaLink, FaVideo } from "react-icons/fa";

// export function FoldersGrid({ folders, onToggleView }) {
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const OpenModal = () => setIsModalOpen(true);
//   const CloseModal = () => setIsModalOpen(false);

//   function CategoryTag({ category }) {
//     const getTagColor = (cat) => {
//       switch (cat) {
//         case "Public":
//           return "text-purple-600";
//         case "UI/UX":
//           return "text-green-600";
//         case "Design":
//           return "text-blue-600";
//         default:
//           return "text-gray-600";
//       }
//     };

//     return (
//       <span className={`text-sm font-medium ${getTagColor(category)}`}>
//         {category}
//       </span>
//     );
//   }
//   return (
//     <div className="space-y-6">
//       <div className="space-y-6">
//         <div className="flex items-center gap-4">
//           <h1 className="text-2xl font-semibold text-[#000000]">Documents</h1>

//           <button
//             onClick={onToggleView}
//             className="px-3 py-1 border-[#3C60FFB2] border rounded-lg"
//           >
//             <span className="text-sm text-gray-600">Assets</span>
//           </button>
//         </div>
//         <div className="flex items-center justify-between">
//           <div className="flex items-center gap-4">
//             <h1 className="text-2xl font-semibold text-gray-900">
//               All Folders (6)
//             </h1>

//             <Link to="/employee">
//               <div className="px-3 py-1 border-[#3C60FFB2] border  rounded-lg">
//                 <span className="text-sm text-gray-600">offboarding</span>
//               </div>
//             </Link>
//           </div>

//           <SimpleButton
//             onClick={OpenModal}
//             className="bg-[#1234CD] hover:bg-blue-700 text-base text-white"
//           >
//             <span className="mr-2">+</span>
//             Add new
//           </SimpleButton>
//         </div>

//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
//           {folders.map((folder) => (
//             <div
//               key={folder.id}
//               className="bg-white rounded-lg p-4 shadow-sm border border-gray-200 hover:shadow-md transition-shadow"
//             >
//               <div className="flex items-start justify-between mb-4">
//                 <span className="text-sm font-medium text-gray-700">
//                   {folder.name}
//                 </span>
//                 <button className="text-gray-400 hover:text-gray-600">
//                   {/* <span className="text-lg">...</span> */}
//                   <img
//                     className=" w-4"
//                     src={moreVertical}
//                     alt="vertical"
//                   />
//                 </button>
//               </div>

//               <div className="flex w-40 justify-center mb-4">
//                 <img
//                   src={folder.image}
//                   alt={folder.name}
//                 />
//               </div>

//               <div className="flex items-center justify-between text-sm">
//                 <CategoryTag category={folder.category} />
//                 <span className="text-gray-500">{folder.date}</span>
//               </div>
//             </div>
//           ))}
//         </div>

//         <Modal
//           isOpen={isModalOpen}
//           onClose={CloseModal}
//         >
//           <div className=" my-10 ">
//             <form
//               // onSubmit={handleImageSubmit}
//               action=""
//             >
//               <p className=" text-[#000000] text-xl font-bold">Add file</p>
//               <div className="grid grid-cols-2 gap-6">
//                 <div className=" my-2 ">
//                   <label
//                     for="title"
//                     htmlFor=""
//                     className="text-[#000000]"
//                   >
//                     First Name
//                   </label>
//                   <div></div>
//                   <input
//                     className=" w-[100%] text-center border-[#D0D0D0] border-2 outline-none rounded-md p-2"
//                     placeholder="Name"
//                     id="title"
//                     type="text"
//                   />
//                 </div>

//                 <div className=" my-2">
//                   <label
//                     className=" text-[#000000]"
//                     htmlFor=""
//                   >
//                     Select Folder
//                   </label>
//                   <div></div>
//                   <input
//                     className=" w-[100%] text-center p-2 border-[#D0D0D0] border-2 outline-none rounded-md"
//                     placeholder="Choose folder"
//                     type="text"
//                   />
//                 </div>
//               </div>

//               <div className="mb-6">
//                 <label
//                   className=" text-[#000000]"
//                   htmlFor=""
//                 >
//                   File description
//                 </label>
//                 <textarea
//                   className=" w-[100%] text-center p-4 border-[#D0D0D0] border-2 outline-none rounded-md"
//                   placeholder="Choose folder"
//                   type="text"
//                 />
//               </div>

//               <p>Share by:</p>
//               <div className="gap-2 py-2 flex">
//                 <input
//                   type="radio"
//                   name=""
//                   id=""
//                 />
//                 <label htmlFor="">Department</label>
//               </div>
//               <div className="gap-2 py-2 flex">
//                 <input
//                   type="radio"
//                   name=""
//                   id=""
//                 />

//                 <label htmlFor="">Level</label>
//               </div>

//               <div className="gap-2 py-2 flex">
//                 <input
//                   type="radio"
//                   name=""
//                   id=""
//                 />

//                 <label htmlFor="">Grade</label>
//               </div>

//               <div className="gap-2 py-2 flex">
//                 <input
//                   type="radio"
//                   name=""
//                   id=""
//                 />
//                 <label htmlFor="">Position</label>
//               </div>

//               <p className="text-black font-bold text-sm">Upload Attachment</p>

//               <div className="flex items-center gap-8 text-sm mt-4">
//                 <button
//                   // onClick={openImageModal}
//                   className="flex items-center gap-1 text-pink-500 hover:text-pink-600 transition"
//                 >
//                   <FaImage className="w-4 h-4" />
//                   Image
//                 </button>
//                 <button className="flex items-center gap-1 text-blue-500 hover:text-blue-600 transition">
//                   <FaVideo className="w-4 h-4" />
//                   Video
//                 </button>
//                 <button className="flex items-center gap-1 text-orange-500 hover:text-orange-600 transition">
//                   <FaLink className="w-4 h-4" />
//                   Link
//                 </button>
//               </div>

//               {/* <div className=" mx-auto grid my-4 justify-center items-center">
//                 <Btn>Post</Btn>
//               </div> */}

//               <SimpleButton
//                 onClick={OpenModal}
//                 className="bg-[#1234CD] p-6 hover:bg-blue-700 text-base text-white"
//               >
//                 <span className="mr-2">+</span>
//                 Post
//               </SimpleButton>
//             </form>
//           </div>
//         </Modal>
//       </div>
//     </div>
//   );
// }

import { Link } from "react-router-dom";
import moreVertical from "../../assets/more-vertical.png";
import { SimpleButton } from "../../components/button.jsx/Btn";
import { createPortal } from "react-dom";
import FolderContextModalDemo, {
  FolderContextModal,
  Modal,
} from "../../components/modal";
import ButtonTag from "../../components/button.jsx/Btn";

import { useState } from "react";
import { FaImage, FaLink, FaVideo } from "react-icons/fa";

export function FoldersGrid({ folders, onToggleView, onFolderNavigation }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalState, setModalState] = useState({
    isOpen: false,
    position: { x: 0, y: 0 },
    folderName: "",
  });
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [folderToRename, setFolderToRename] = useState("");

  const openFolderModal = (folderName, position) => {
    setModalState({
      isOpen: true,
      folderName,
      position,
    });
  };

  const closeFolderModal = () => {
    setModalState((prev) => ({ ...prev, isOpen: false }));
  };

  const handleRenameClick = (folderName) => {
    setFolderToRename(folderName);
    setShowRenameModal(true);
  };

  const handleSaveRename = () => {
    console.log("Renamed to:", folderToRename);
    setShowRenameModal(false);
  };

  const handleMenuClick = (event, folderName) => {
    event.preventDefault();
    const rect = event.target.getBoundingClientRect();
    setModalState({
      isOpen: true,
      position: {
        x: rect.left - 150, // Position modal to the left of the button
        y: rect.bottom + 5, // Position modal below the button
      },
      folderName,
    });
  };

  const folderModalClose = () => {
    setModalState((prev) => ({ ...prev, isOpen: false }));
  };

  const OpenModal = () => setIsModalOpen(true);
  const CloseModal = () => setIsModalOpen(false);

  function CategoryTag({ category }) {
    const getTagColor = (cat) => {
      switch (cat) {
        case "Public":
          return "text-purple-600";
        case "UI/UX":
          return "text-green-600";
        case "Design":
          return "text-blue-600";
        default:
          return "text-gray-600";
      }
    };
    return (
      <span className={`text-sm font-medium ${getTagColor(category)}`}>
        {category}
      </span>
    );
  }

  const handleModalNavigation = (page) => {
    if (typeof onFolderNavigation === "function") {
      onFolderNavigation(page, modalState.folderName);
    } else {
      console.error(
        "[v0] onFolderNavigation is not a function:",
        onFolderNavigation
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: handle form data here
    CloseModal();
  };

  return (
    <div className="space-y-6">
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center gap-4">
          <h1 className="text-2xl font-semibold text-[#000000]">Documents</h1>
          <button
            onClick={onToggleView}
            className="px-3 py-1 border-[#3C60FFB2] border rounded-lg"
          >
            <span className="text-sm text-black">Assets</span>
          </button>
        </div>

        {/* Sub Header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <h1 className="text-2xl font-semibold text-black">
              All Folders ({folders.length})
            </h1>

            <Link to="/employee">
              <div className="px-3 py-1 border-[#3C60FFB2] border rounded-lg">
                <span className="text-sm text-black">Offboarding</span>
              </div>
            </Link>
          </div>

          <SimpleButton
            onClick={OpenModal}
            className="bg-[#1234CD] px-6 py-3 rounded-full hover:bg-blue-700 text-base text-white"
          >
            Add new
          </SimpleButton>
        </div>

        {/* Folders Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-6">
          {folders.map((folder) => (
            <div
              key={folder.id}
              className="bg-white rounded-lg p-4 shadow-sm border border-gray-200 hover:shadow-md transition-shadow"
            >
              <div className="flex items-start justify-between mb-4">
                <span className="text-sm font-medium text-black">
                  {folder.name}
                </span>
                <button
                  onClick={(e) => handleMenuClick(e, folder.name)}
                  className="text-black hover:text-gray-600"
                >
                  <img
                    className="w-4"
                    src={moreVertical}
                    alt="vertical"
                  />
                </button>
              </div>

              <div className="flex w-40 justify-center mb-4">
                <img
                  src={folder.image}
                  alt={folder.name}
                />
              </div>

              <div className="flex items-center justify-between text-sm">
                <CategoryTag category={folder.category} />
                <span className="text-black">{folder.date}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Modal */}
        <Modal
          isOpen={isModalOpen}
          onClose={CloseModal}
        >
          <div>
            <form onSubmit={handleSubmit}>
              <p className="text-[#000000] text-xl font-bold">Add file</p>

              <div className="grid grid-cols-2 gap-6">
                <div className="my-2">
                  <label
                    htmlFor="title"
                    className="text-[#000000]"
                  >
                    First Name
                  </label>
                  <input
                    className="w-full text-center border-[#D0D0D0] border-2 outline-none rounded-md p-2"
                    placeholder="Name"
                    id="title"
                    type="text"
                  />
                </div>

                <div className="my-2">
                  <label
                    htmlFor="folder"
                    className="text-[#000000]"
                  >
                    Select Folder
                  </label>
                  <input
                    className="w-full text-center p-2 border-[#D0D0D0] border-2 outline-none rounded-md"
                    placeholder="Choose folder"
                    id="folder"
                    type="text"
                  />
                </div>
              </div>

              <div className="mb-6">
                <label
                  htmlFor="desc"
                  className="text-[#000000]"
                >
                  File description
                </label>
                <textarea
                  id="desc"
                  className="w-full text-center p-4 border-[#D0D0D0] border-2 outline-none rounded-md"
                  placeholder="Enter description"
                />
              </div>

              {/* Radio Group */}
              <p>Share by:</p>
              {["Department", "Level", "Grade", "Position"].map((option) => (
                <div
                  key={option}
                  className="gap-2 py-2 flex"
                >
                  <input
                    type="radio"
                    name="shareBy"
                    id={option}
                    value={option}
                  />
                  <label htmlFor={option}>{option}</label>
                </div>
              ))}

              {/* Upload Section */}
              <p className="text-black font-bold text-sm mt-4">
                Upload Attachment
              </p>

              <div className="flex items-center gap-8 text-sm mt-4">
                <button
                  type="button"
                  className="flex items-center gap-1 text-pink-500 hover:text-pink-600 transition"
                >
                  <FaImage className="w-4 h-4" />
                  Image
                </button>
                <button
                  type="button"
                  className="flex items-center gap-1 text-blue-500 hover:text-blue-600 transition"
                >
                  <FaVideo className="w-4 h-4" />
                  Video
                </button>
                <button
                  type="button"
                  className="flex items-center gap-1 text-orange-500 hover:text-orange-600 transition"
                >
                  <FaLink className="w-4 h-4" />
                  Link
                </button>
              </div>

              <div className="mx-auto justify-center items-center flex">
                <SimpleButton
                  type="submit"
                  className="bg-[#1234CD] mx-auto
                 w-[180px] h-[59px] flex justify-center items-center text-center  mt-6 p-3 hover:bg-blue-700 text-xl text-white"
                >
                  Create
                </SimpleButton>
              </div>
            </form>
          </div>
        </Modal>

        <FolderContextModal
          isOpen={modalState.isOpen}
          onClose={folderModalClose}
          position={modalState.position}
          folderName={modalState.folderName}
          onNavigate={handleModalNavigation}
        />

        {/* <FolderContextModal
          isOpen={modalState.isOpen}
          folderName={modalState.folderName}
          position={modalState.position}
          onClose={closeFolderModal}
          onRename={handleRenameClick}
        /> */}

        {/* <FolderContextModalDemo /> */}

        {/* RENAME MODAL (PORTAL) */}
        {showRenameModal &&
          createPortal(
            <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[9999]">
              <div className="bg-white rounded-lg p-6 w-80 shadow-xl">
                <h2 className="text-lg font-semibold mb-4">Rename Folder</h2>

                <input
                  type="text"
                  value={folderToRename}
                  onChange={(e) => setFolderToRename(e.target.value)}
                  className="w-full border px-3 py-2 rounded mb-4"
                />

                <div className="flex justify-end space-x-3">
                  <button
                    onClick={() => setShowRenameModal(false)}
                    className="px-4 py-2 bg-gray-200 rounded"
                  >
                    Cancel
                  </button>

                  <button
                    onClick={handleSaveRename}
                    className="px-4 py-2 bg-blue-600 text-white rounded"
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>,
            document.body
          )}
      </div>
    </div>
  );
}
